<div class="card">
  <div class="card-header"><mat-icon>filter_list</mat-icon> Filters</div>
  <div class="card-body">
    <div class="row" style="margin-top: 15px">
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Item Number</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            [class.highlight]="model.itemNumber"
            [(ngModel)]="model.itemNumber"
            name="itemNumber"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Type</label>
          <select
            class="form-control"
            [class.highlight]="model.type"
            [(ngModel)]="model.type"
            name="type"
          >
            <option></option>
            <option *ngFor="let t of wasteTypeOptions" [value]="t">{{t}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Shipped</label>
          <select
            class="form-control"
            [class.highlight]="model.shipped"
            [(ngModel)]="model.shipped"
            name="shipped"
          >
            <option></option>
            <option [value]="'Yes'">Yes</option>
            <option [value]="'No'">No</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Start Date</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            [class.highlight]="model.startDate"
            [(ngModel)]="model.startDate"
            name="startDate"
            bsDatepicker
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Item Detail</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            [class.highlight]="model.itemDetail"
            [(ngModel)]="model.itemDetail"
            name="itemDetail"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Stream Name</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            [class.highlight]="model.streamName"
            [(ngModel)]="model.streamName"
            name="streamName"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">Container Number</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [class.highlight]="model.containerNumber"
              [(ngModel)]="model.containerNumber"
              name="containerNumber"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">Container Detail</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [class.highlight]="model.containerDetail"
              [(ngModel)]="model.containerDetail"
              name="containerDetail"
            />
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="card">
      <div class="card-header"><em class="material-icons">sort</em> Sorting & Paging</div>
      <div class="card-body">
        <div class="row" style="margin-top: 15px">
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label">Sort By</label>
              <select class="form-control" [(ngModel)]="model.sortBy" name="sortBy">
                <option></option>
                <option *ngFor="let s of sortOptions" [value]="s">{{s}}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="control-label">Page Size</label>
              <input
                type="number"
                class="form-control"
                [(ngModel)]="model.pageSize"
                name="pageSize"
              />
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label">Sort Direction</label>
              <select class="form-control" [(ngModel)]="model.sortDirection" name="sortDirection">
                <option></option>
                <option [value]="'Asc'">Ascending</option>
                <option [value]="'Desc'">Descending</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
